import { render } from "./AppFormCheckbox.vue?vue&type=template&id=2815faed&scoped=true"
import script from "./AppFormCheckbox.vue?vue&type=script&lang=js"
export * from "./AppFormCheckbox.vue?vue&type=script&lang=js"

import "./AppFormCheckbox.vue?vue&type=style&index=0&id=2815faed&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2815faed"]])

export default __exports__